export function IvyChatArrowUpIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={18}
      viewBox="0 0 15 18"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M7.5 15.25V2.75M7.5 2.75 3.5 6.75M7.5 2.75l4 4"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function IvyChatSubmitButton() {
  return (
    <button
      type="button"
      className="ivy-chat-submit"
      disabled
      tabIndex={-1}
      aria-hidden
    >
      <IvyChatArrowUpIcon className="ivy-chat-submit__icon" />
    </button>
  )
}
